<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	import { copy } from '../../../../helpers/copy_text';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
	//Design system components
	import { Text, IconButton, Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	import type { Device } from '../../../../types/Device';
	import type { InputClickEvent } from '../../../../types/InputClickEvent';
	export let device: Device;

	const id = real_id(device.id),
		ip = device.ip,
		settings = readDeviceSettings(id)?.thermostats[0],
		save = async (e: InputClickEvent) => {
			waitForResponse = true;
			enabled = e.target.checked;
			const res: SettingRequest = await postReq(
				`/device/generic_command`,
				{
					id,
					command: 'open_window_report',
					payload: JSON.stringify({
						id: device.channel,
						enabled,
					}),
				},
				20000,
			);
			onSettingsResponse(res, device);
			waitForResponse = false;
		};
	const url = `http://${ip}/window?state=open/close`;

	let enabled = settings?.open_window_report,
		waitForResponse = false;
</script>

<Toggle
	size="m"
	disabled={waitForResponse}
	checked={enabled}
	class="mb-s"
	on:click={save}
	id="toggle-fay7umx"
>
	{$format('open_window_description_no_ip', {
		default: `Enable open window report endpoint`,
	})}
</Toggle>

<div class="d-flex flex-wrap">
	<div class="d-flex flex-auto justify-content-between align-items-center">
		<Text styleType={'body-small'} class={'text-small'}>{url}</Text>
		<IconButton
			icon="fas fa-copy"
			class="ml-s"
			on:click={() =>
				copy(
					url,
					$format('copied_successfully', {
						default: 'Copied successfully!',
					}),
				)}
			aria-label={$format('button_copy', { default: 'Copy' })}
		/>
	</div>
</div>
